class NewsletterSignup extends HTMLElement {
  constructor() {
    super();
    this.customerSignupForm = document.getElementById('create_customer');
    this.customerSignupForm.addEventListener('submit', () => this.bloomreachTrackEvent(this));
  }

  bloomreachTrackEvent() {
    const marketingPreference = this.customerSignupForm.querySelector('.marketing_preference').checked;
    const emailValue = this.customerSignupForm.querySelector('input[type="email"]').value

    if (marketingPreference && emailValue !== '') {
      exponea.identify(
        { email_id: emailValue.toLowerCase().trim() },
        { email: emailValue.toLowerCase().trim() }
      );
      
      exponea.track('consent', {
        "action": "accept",
        "category": "Marketing",
        "valid_until": "unlimited",
        "message": "This consent was tracked from landing page"
      });
    }
  }
}

customElements.define('register-form', NewsletterSignup);
